
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { User, Building, Mail } from 'lucide-react';
import { ContactInfo } from '@/types/assessment';
import { NOKODIA_COLORS } from '@/utils/assessmentUtils';
import { useCalendlyModal } from '@/hooks/useCalendlyModal';
import { trackCalendlyClicked } from '@/hooks/useGA4Events';

interface AssessmentIntroSectionProps {
  contactInfo: ContactInfo;
  assessmentType?: 'ia-diagnostic' | 'training-transformation';
}

export const AssessmentIntroSection: React.FC<AssessmentIntroSectionProps> = ({
  contactInfo,
  assessmentType = 'ia-diagnostic'
}) => {
  const { openHubSpotMeeting } = useCalendlyModal();

  const handleCalendlyClick = () => {
    trackCalendlyClicked('assessment_intro');
    openHubSpotMeeting();
  };

  return (
    <Card className="border-2 border-gray-100">
      <CardContent className="p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center">
          {/* Colonne gauche */}
          <div className="text-left space-y-4">
            <h2 className="text-2xl font-bold" style={{ color: NOKODIA_COLORS.primary }}>
              Votre potentiel IA est identifié
            </h2>
            <p className="text-gray-700 text-lg">
              <strong>{contactInfo.firstName}</strong>, voici le diagnostic complet pour <strong>{contactInfo.company || 'votre entreprise'}</strong>
            </p>
            
            <div className="space-y-2 text-gray-600">
              <div className="flex items-center gap-2">
                <User className="h-4 w-4" style={{ color: '#FF6600' }} />
                <span>{contactInfo.firstName} {contactInfo.lastName}</span>
              </div>
              
              {contactInfo.company && (
                <div className="flex items-center gap-2">
                  <Building className="h-4 w-4" style={{ color: '#FF6600' }} />
                  <span>{contactInfo.company}</span>
                </div>
              )}
              
              <div className="flex items-center gap-2">
                <Mail className="h-4 w-4" style={{ color: '#FF6600' }} />
                <span>{contactInfo.email}</span>
              </div>
            </div>
          </div>

          {/* Colonne droite - CTA */}
          <div className="bg-orange-50 border border-orange-200 rounded-lg p-6 text-center">
            <h3 className="text-xl font-bold mb-3" style={{ color: NOKODIA_COLORS.primary }}>
              Et maintenant ?
            </h3>
            <p className="text-gray-700 mb-4">
              Passez à l'action en prenant RDV avec un expert.
            </p>
            <a
              href="https://meetings.hubspot.com/gbarre?uuid=2e9e3088-56f5-414e-94c6-34983e31a2fc"
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleCalendlyClick}
              className="inline-block rounded-full text-white px-6 md:px-8 py-3 md:py-4 font-semibold hover:scale-105 transition-all duration-300 text-sm md:text-base"
              style={{
                background: 'linear-gradient(135deg, #D7398B, #FF6600)'
              }}
            >
              Réserver un RDV de debrief
            </a>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
